// extracted by mini-css-extract-plugin
export default {"guidedTourStep":"styles_guidedTourStep__0fog8","title":"styles_title__nmUR1","content":"styles_content__ywQ2S","closeButton":"styles_closeButton__z3HSz"};